import { useEffect, useState } from "react";
import Stripe from "stripe";

import { Plan } from "lib/stripe";
import { useGetLoginStatus, useGetUser } from "lib/auth";
import { useGetLocation } from "lib/location";

import Signup from "elements/Signup";
import PricingFAQs from "elements/Pricing-FAQs";

import PlanComponent from "./Plan";
import CouponComponent from "./Coupon";
import PlanLengthSelect from "./Plan-Length-Select";

import useHandleCheckout from "./checkout";

interface Props {
  plans: Plan[];
  coupon?: Stripe.Coupon | null;
  selectedPlan?: string;
  showFAQs?: boolean;
}

const Pricing = ({ plans, selectedPlan, showFAQs, coupon }: Props) => {
  const location = useGetLocation();
  const [planLength, setPlanLength] = useState<"monthly" | "annual">("annual");
  const [handleCheckout] = useHandleCheckout();
  const [selectedFlag, setSelectedFlag] = useState<string | null>(selectedPlan);

  const loggedIn = useGetLoginStatus();
  const user = useGetUser();

  const email = user?.email;

  useEffect(() => {
    if (selectedFlag && loggedIn && email) {
      handleCheckout(selectedFlag);
    }
  }, [loggedIn, selectedFlag, handleCheckout, email]);

  if (!loggedIn && selectedFlag) {
    return (
      <Signup
        action="sign-up"
        redirectUrl={`/signup?next=/pricing&plan=${setSelectedFlag}`}
      />
    );
  }

  if (loggedIn && selectedFlag) {
    return (
      <div className="mt-4 pt-4">
        <p className="font-bold text-xl text-center">
          Redirecting to Payment Gateway...
        </p>
      </div>
    );
  }

  return (
    <>
      <PlanLengthSelect planLength={planLength} setPlanLength={setPlanLength} />
      {coupon && (
        <div className="px-12 pb-4 mt-4">
          <CouponComponent coupon={coupon} />
        </div>
      )}
      <div className="grid sm:grid-cols-1 md:grid-cols-4 gap-4">
        {plans.map((p, i) => (
          <PlanComponent
            key={p.name}
            plan={p}
            prevPlan={plans[i - 1]}
            planLength={planLength}
            location={location}
            onSelect={setSelectedFlag}
            coupon={coupon}
          />
        ))}
      </div>
      {showFAQs && <PricingFAQs page="pricing" />}
    </>
  );
};

export default Pricing;
